import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableProductsDepot from "../../ui/DataTableProductsDepot";

const EtatStocksDetails = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [availableWarehouses, setAvailableWarehouses] = useState([]);

  useEffect(() => {
    startLoading();
    const idStockswarehouse = sessionStorage.getItem("idStockswarehouse");
    WarehouseService.getProductStockByWarehouseAndQctInvalid(
      getCurrentUserId(),
      idStockswarehouse
    )
      .then((response) => {
        setAvailableWarehouses(response.data.success);
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const warehouse = availableWarehouses?.warehouse;
  const lengthOf = (list) => (list ? list.length : 0);

  const kpis = [
    {
      label: "Stock inférieur",
      value: lengthOf(availableWarehouses?.infQctMin),
      icon: "fas fa-arrow-down",
      color: "#dc3545",
    },
    {
      label: "Stock supérieur",
      value: lengthOf(availableWarehouses?.supQctMax),
      icon: "fas fa-arrow-up",
      color: "#28a745",
    },
    {
      label: "Stock normal",
      value: lengthOf(availableWarehouses?.reste),
      icon: "fas fa-equals",
      color: "#17a2b8",
    },
  ];

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-warehouse mr-2"></i>
                {warehouse ? `${warehouse.ref} - ${warehouse.name}` : "Dépôt"}
              </h4>
              <small className="text-muted">
                Produits du dépôt classés selon leurs seuils de stock
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/EtatStocks")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour à l'état des stocks
            </button>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row mt-3">
            {kpis.map((k) => (
              <div className="col-md-4" key={k.label}>
                <div
                  className="d-flex align-items-center p-3 mb-3 bg-white"
                  style={{
                    borderRadius: 8,
                    boxShadow: "0 1px 6px rgba(0,0,0,.08)",
                    borderLeft: `4px solid ${k.color}`,
                  }}
                >
                  <span
                    className="d-flex align-items-center justify-content-center text-white mr-3"
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 8,
                      backgroundColor: k.color,
                    }}
                  >
                    <i className={k.icon}></i>
                  </span>
                  <div>
                    <small
                      className="text-muted text-uppercase d-block"
                      style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                    >
                      {k.label}
                    </small>
                    <span style={{ fontSize: "1.4rem", fontWeight: 700 }}>
                      {k.value}
                    </span>
                    <small className="text-muted ml-1">produits</small>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {availableWarehouses && availableWarehouses.infQctMin && (
            <DataTableProductsDepot
              products={availableWarehouses.infQctMin}
              title="Les produits inférieurs au stock min"
              icon="fas fa-arrow-down"
              color="#dc3545"
            />
          )}
          {availableWarehouses && availableWarehouses.supQctMax && (
            <DataTableProductsDepot
              products={availableWarehouses.supQctMax}
              title="Les produits supérieurs au stock max"
              icon="fas fa-arrow-up"
              color="#28a745"
            />
          )}
          {availableWarehouses && availableWarehouses.reste && (
            <DataTableProductsDepot
              products={availableWarehouses.reste}
              title="Le reste des produits"
              icon="fas fa-equals"
              color="#17a2b8"
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default withLoader(EtatStocksDetails);
